import { Link } from "react-router-dom";

import ArrowLeft from "../../components/LogoSVG/ArrowLeft";
import ArticleHeaderDesktop from "../../components/Global/ArticleHeaderDesktop";
import Header1Desktop from "../../components/Global/Header1Desktop";
import Paragraph from "../../components/Global/Paragraph";
import Header2Desktop from "../../components/Global/Header2Desktop";
import Circle from "../../components/LogoSVG/Circle";
import TechStackComponent from "../../components/Global/TechStackComponent";
import CombineTechStackComponent from "../../components/Global/CombineTechStackComponent";
import ListFourImages from "../../components/Global/ListFourImages";

import thumbnail from "../../public/thumbnail-thesis-2.png";
import expoLogo from "../../public/expo.png";
import firebaseLogo from "../../public/firebaseLogo.png";
import tsLogo from "../../public/ts-logo.png";
import algoliaLogo from "../../public/algoliaLogo.png";
import gcpLogo from "../../public/gcpLogo.png";
import architectureThesis from "../../public/architectureThesis.png";
import limitDiaries from "../../public/thesis/limitDiaries.png";
import image1 from "../../public/thesis/1.png";
import image2 from "../../public/thesis/2.png";
import image3 from "../../public/thesis/3.png";
import image4 from "../../public/thesis/4.png";
import image5 from "../../public/thesis/5.png";
import image6 from "../../public/thesis/6.png";
import image7 from "../../public/thesis/7.png";
import image8 from "../../public/thesis/8.png";
import image9 from "../../public/thesis/9.png";
import image10 from "../../public/thesis/10.png";
import image11 from "../../public/thesis/11.png";
import image12 from "../../public/thesis/12.png";
import image13 from "../../public/thesis/13.png";
import image14 from "../../public/thesis/14.png";
import image15 from "../../public/thesis/15.png";
import image16 from "../../public/thesis/16.png";
import image17 from "../../public/thesis/17.png";
import image18 from "../../public/thesis/18.png";
import image19 from "../../public/thesis/19.png";
import image20 from "../../public/thesis/20.png";
import image21 from "../../public/thesis/21.png";
import image22 from "../../public/thesis/22.png";
import image23 from "../../public/thesis/23.png";
import image24 from "../../public/thesis/24.png";
import image25 from "../../public/thesis/25.png";
import image26 from "../../public/thesis/26.png";
import image27 from "../../public/thesis/27.png";
import image28 from "../../public/thesis/28.png";
import image29 from "../../public/thesis/29.png";
import image30 from "../../public/thesis/30.png";
import image31 from "../../public/thesis/31.png";
import image32 from "../../public/thesis/32.png";
import image33 from "../../public/thesis/33.png";
import image34 from "../../public/thesis/34.png";
import image35 from "../../public/thesis/35.png";
import image36 from "../../public/thesis/36.png";
import image37 from "../../public/thesis/37.png";
import image38 from "../../public/thesis/38.png";

function ThesisDesktop() {
  return (
    <div className="mx-auto max-w-[800px] px-6 pb-44 pt-12">
      <Link to={"/"} className="flex items-center cursor-pointer">
        <ArrowLeft className="w-6 h-6" />
        <p className="ml-2 mt-1 font-normal text-gray-5 text-center hover:text-custom-white">
          Back
        </p>
      </Link>

      <ArticleHeaderDesktop
        thumbnail={thumbnail}
        title="My Bachelor's Thesis: An Intelligent Digital Diary Application"
        description="Focus on comprehensively researching and developing an Intelligent Digital Diary to replace traditional handwritten diaries and enhance the journaling experience through innovative features."
        note="This is just my personal blog post, not the official thesis document."
        date="Oct 07, 2024"
        youtube="https://www.youtube.com/watch?v=AZa2V3BU1Vc"
      />

      <Header1Desktop>Acknowledging the Guidance</Header1Desktop>
      <Paragraph>
        I would like to express my deepest appreciation to my thesis advisor,
        <span className=" ml-2">
          <a
            className=" text-custom-green"
            href="https://www.fit.hcmus.edu.vn/~dbtien/"
            target="_blank"
          >
            Dr. Dinh Ba Tien
          </a>
          , the Dean of the Faculty of Computer Science at the University of
          Science (HCMUS), Vietnam National University
        </span>
        . His guidance and inspiration have carried me through every stage of
        this thesis. He consistently created opportunities for me to improve my
        work by offering valuable resources and expanding my network. Without
        his support, this thesis would not have succeeded.
      </Paragraph>

      <Header1Desktop>Overview</Header1Desktop>
      <Paragraph>
        In the era of digital transformation, there is a growing need to
        leverage the latest technologies to keep pace with the advancements of
        developed countries, particularly in the realm of journaling. Both
        traditional manual diary-writing and some existing journaling platforms
        present several challenges that can be effectively addressed through
        modern technological solutions.
      </Paragraph>

      <Header2Desktop>Problem - Why?</Header2Desktop>

      <Paragraph>The idea came from when I first noticed:</Paragraph>
      <Paragraph className="underline underline-offset-4 " isDot>
        Limitations of Traditional Journaling:
      </Paragraph>
      <Paragraph className="ml-[18px]">
        Reveal limitations in terms of storage, management, and tracking as
        the quantity of entries grows.
      </Paragraph>
      <Paragraph className="ml-[18px]">
        Adding and integrating photos into these diaries often lacks
        flexibility. The manual process of cutting and collaging photos can be
        time-consuming and messy.
      </Paragraph>
      <Paragraph className="ml-[18px]">
        When we want to modify diary entries, it's definitely time-consuming,
        which detracts from the relaxing experience we want after a stressful
        day.
      </Paragraph>
      <Paragraph className="ml-[18px]">Damage and loss over time.</Paragraph>

      <img
        alt=""
        fetchPriority="high"
        decoding="async"
        data-nimg="1"
        className="rounded-lg ml-10 w-[calc(80%+10px)] max-w-none mt-8 mb-12"
        style={{ color: "transparent" }}
        src={limitDiaries}
      ></img>

      <Paragraph className="underline underline-offset-4 " isDot>
        Current Limitations of Existing Digital Diary Applications:{" "}
      </Paragraph>
      <Paragraph className="ml-[18px]">
        Some digital diary applications are often fragmented and lack
        cohesion.
      </Paragraph>
      <Paragraph className="ml-[18px]">
        Many suffer limited functionalities, poor multimedia integration, and
        a lack of AI-driven insights and modern technologies.
      </Paragraph>

      <Header1Desktop>My Contributions</Header1Desktop>
      <Header2Desktop>To solve the above problems:</Header2Desktop>
      <div className="flex flex-row items-start">
        <p className={`text-gray-6 mb-5 text-pretty tracking-[0.025em]`}>
          Researched and implemented a comprehensive set of features designed to
          meet the diverse needs of modern users, along with a logical and
          efficient diary management system.
        </p>
      </div>
      <div className="flex flex-row items-start">
        <p className={`text-gray-6 text-pretty tracking-[0.025em]`}>
          I integrated several advanced technologies like AI, Optical Character
          Recognition (OCR), Text-to-Speech (TTS), Cloud Computing to build a
          user-centric application. Together, these technologies provided a more
          engaging and personalized journaling experience.
        </p>
      </div>

      <Header1Desktop>Technology</Header1Desktop>
      <Paragraph>
        For my thesis, I mainly used TypeScript as I chose the React Native
        framework and Expo ecosystem for mobile development. On the backend, I
        leveraged the Firebase SDK for authentication, real-time database
        management, file storage, and data handling. The reasons why I chose
        Firebase SDK is its integration and scalability. Firebase offers a fully
        managed platform that simplifies backend development by handling
        infrastructure maintenance, database scaling, and server management.
      </Paragraph>

      <div className="flex flex-row justify-around mt-16 mb-16">
        <TechStackComponent name="TypeScript" logo={tsLogo} />
        <TechStackComponent name="Expo" logo={expoLogo} />
        <TechStackComponent name="Firebase" logo={firebaseLogo} />
        <TechStackComponent name="Algolia" logo={algoliaLogo} />
      </div>

      <Paragraph>
        To enhance functionality, I incorporated third-party services such as
        Google Cloud Platform (GCP) for a wide range of features and Algolia for
        full-text search, which improved data indexing and optimized search
        capabilities within a high-performance cluster.
      </Paragraph>

      <div className="flex flex-row justify-around mb-16 mt-16">
        <CombineTechStackComponent
          name1="Google Cloud Platform"
          logo1={gcpLogo}
          name2="Optical Character Recognition"
          name3="Text-to-Speech"
          name4="Gemini"
          name5="Geocoding API"
        />
      </div>

      <Header1Desktop>Architecture</Header1Desktop>
      <Paragraph>
        The figure illustrates the overall architecture of our application,
        showing the major components and their connections.
      </Paragraph>
      <img
        alt=""
        fetchPriority="high"
        decoding="async"
        data-nimg="1"
        className="rounded-lg ml-10 w-[calc(80%+10px)] max-w-none mt-8 mb-16"
        style={{ color: "transparent" }}
        src={architectureThesis}
      ></img>

      <Header1Desktop>An Intelligent Digital Diary Application</Header1Desktop>

      <Paragraph>You can enjoy my short demo here:</Paragraph>
      <div className="w-[calc(80%+10px)] mx-auto mb-10">
        <iframe
          width="560"
          height="315"
          src={`https://www.youtube.com/embed/AZa2V3BU1Vc`}
          title="YouTube video player"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
        ></iframe>
      </div>

      <Header2Desktop>Home Screen</Header2Desktop>
      <ListFourImages
        className="mt-8  mb-8"
        image1={image4}
        image2={image1}
        image3={image2}
        image4={image3}
      />

      <Header2Desktop>Create a new Diary</Header2Desktop>
      <ListFourImages
        className="mt-8 mb-4"
        image1={image5}
        image2={image9}
        image3={image7}
        image4={image8}
      />
      <ListFourImages
        className="mt-2  mb-8"
        image1={image10}
        image2={image11}
        image3={image12}
        image4={image6}
      />

      <Header2Desktop>View Diaries List</Header2Desktop>
      <ListFourImages className="mt-8 mb-8" image1={image13} image2={image14} />

      <Header2Desktop>Text-to-Speech feature</Header2Desktop>
      <ListFourImages className="mt-8 mb-8" image1={image15} image2={image16} />

      <Header2Desktop>Share Diaries with Friends Within the App</Header2Desktop>
      <ListFourImages
        className="mt-8 mb-8"
        image1={image17}
        image2={image18}
        image3={image19}
        image4={image20}
      />

      <Header2Desktop>Share Diaries to Social Platforms</Header2Desktop>
      <ListFourImages
        className="mt-8 mb-8"
        image1={image21}
        image2={image22}
        image3={image23}
      />

      <Header2Desktop>Digitize Handwritten Diaries</Header2Desktop>
      <ListFourImages
        className="mt-8 mb-8"
        image1={image38}
        image2={image24}
        image3={image25}
        image4={image26}
      />

      <Header2Desktop>Analysis Emotion</Header2Desktop>
      <ListFourImages
        className="mt-8 mb-8"
        image1={image27}
        image2={image28}
        image3={image29}
      />

      <Header2Desktop>Search Diaries</Header2Desktop>
      <ListFourImages
        className="mt-8 mb-8"
        image1={image33}
        image2={image30}
        image3={image32}
        image4={image31}
      />

      <Header2Desktop>
        Daily Reminder - Summarize Memories - View the Gallery
      </Header2Desktop>
      <ListFourImages
        className="mt-8 mb-8"
        image1={image35}
        image2={image36}
        image3={image37}
        image4={image34}
      />

      <a
        className=" text-custom-green font-medium tracking-[0.025em] mb-1 text-[18px]"
        href="https://www.youtube.com/watch?v=AZa2V3BU1Vc"
        target="_blank"
      >
        Several small features were also added - Enjoy the demo for more
        details.
      </a>

      <Header2Desktop className="mt-12 font-normal">
        If you're curious about the location-picking mechanism using a
        performance-oriented approach similar to Grab, Uber, and others, please
        check out{" "}
        <a
          className="underline underline-offset-4 text-custom-green font-medium tracking-[0.025em] mb-1 text-[18px]"
          href="/blog/map"
          target="_blank"
        >
          this blog
        </a>
      </Header2Desktop>

      <Header1Desktop>Thank you for reading this post !!</Header1Desktop>
    </div>
  );
}

export default ThesisDesktop;
